module.exports = __webpack_public_path__ + "static/media/podopieczny.e32e50b5.jpg";